import { render, staticRenderFns } from "./lianxiwomen.vue?vue&type=template&id=6d23ad00&scoped=true"
import script from "./lianxiwomen.vue?vue&type=script&lang=js"
export * from "./lianxiwomen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d23ad00",
  null
  
)

export default component.exports